module.exports = __webpack_public_path__ + "static/media/warranty_part2.60934175.png";